<template>
  <div class="wrapper">
    <div class="stats" v-if="stats">
      <v-card
        :width="showStats ? 350 : 150"
        min-height="50"
        class="mr-4 rounded-1"
        color="rgb(255, 255, 255, 0.8)"
      >
        <v-card-actions>
          <p class="black--text ma-0 ml-4">الاحصائيات</p>
          <v-spacer></v-spacer>
          <v-btn icon @click="showStats = !showStats" color="black">
            <v-icon>{{
              showStats ? "mdi-chevron-left" : "mdi-chevron-right"
            }}</v-icon>
          </v-btn>
        </v-card-actions>
        <v-expand-transition>
          <v-simple-table v-show="showStats" height="70vh" class="sim-table">
            <template v-slot:default>
              <thead>
                <tr>
                  <th class="text-center">الاسم</th>
                  <th class="text-center">المحافظة</th>
                  <th class="text-center">العنوان</th>
                </tr>
              </thead>

              <tbody>
                <tr
                  v-for="(item, index) in stats"
                  :key="index"
                  class="text-right"
                  :class="itemRowBackground(item, index)"
                >
                  <td>{{ item.name }}</td>
                  <td>{{ item.governorate.name }}</td>
                  <td>{{ item.location }}</td>
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </v-expand-transition>
        <v-row no-gutters>
          <v-col cols="12">
            <p
              v-show="showStats"
              class="text-center pa-0 ma-0 my-4 text-subtitle-1 black--text"
            >
              اضغط على المحافظة لاستعراض اعداد المشاريع
            </p>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <div id="map" ref="map">
      <MapMarker
        :v-if="cities.length > 0"
        v-for="(city, index) in cities"
        :key="index"
        :lat="getLat(city)"
        :lng="getLng(city)"
        :index="index"
        :name="city.name"
      />
      <v-dialog v-model="loadingDialog" hide-overlay persistent width="300">
        <v-card color="primary" dark class="pa-4">
          <v-card-text>
            يرجى الانتظار...
            <v-progress-linear
              indeterminate
              color="accent"
              class="mt-4"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <SharedSectorCityDialog
        v-if="selectedCitySharedProjects"
        :visible="cityDialog"
        :selectedCitySharedProjects="selectedCitySharedProjects"
        :selectedCity="selectedCity"
        @close="cityDialog = false"
      />
      <AddSharedProjectDialog
        v-if="addProjectDialog"
        :visible="addProjectDialog"
        @close="addProjectDialog = false"
      />
      <ImportSharedProjectsDialog
        v-if="importProjectDialog"
        :visible="importProjectDialog"
        @close="importProjectDialog = false"
      />
    </div>
    <div class="foo" v-if="this.user.type != `User`">
      <v-speed-dial
        v-model="fab"
        top
        direction="top"
        transition="slide-y-reverse-transition"
      >
        <template v-slot:activator>
          <v-btn v-model="fab" color="blue darken-2" dark fab>
            <v-icon v-if="fab"> mdi-close </v-icon>
            <v-icon v-else> mdi-plus-circle </v-icon>
          </v-btn>
        </template>
        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              dark
              small
              v-bind="attrs"
              v-on="on"
              color="accent"
              @click="AddProject"
            >
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </template>
          <span>اضافة مشروع</span>
        </v-tooltip>

        <v-tooltip left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              fab
              dark
              small
              v-bind="attrs"
              v-on="on"
              color="primary"
              @click="ImportProject"
            >
              <v-icon>mdi-file-excel</v-icon>
            </v-btn>
          </template>
          <span>اضافة Excel</span>
        </v-tooltip>
      </v-speed-dial>
    </div>
  </div>
</template>
<script>
import MapMarker from "@/components/MapMarker.vue";
import SharedSectorCityDialog from "@/components/mixed_sector/SharedSectorCityDialog.vue";
import AddSharedProjectDialog from "@/components/mixed_sector/AddSharedProjectDialog.vue";
import ImportSharedProjectsDialog from "@/components/mixed_sector/ImportSharedProjectsDialog.vue";
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "MapView",
  data() {
    return {
      map: null,
      marker: null,
      markers: [],
      cities: null,
      selectedCitySharedProjects: null,
      selectedCity: null,
      cityDialog: false,
      mapStyle: "",
      projects: [],
      loadingDialog: false,
      addProjectDialog: false,
      importProjectDialog: false,
      stats: "",
      sections: [],
      fab: false,
      showStats: false,
    };
  },
  components: {
    MapMarker,
    SharedSectorCityDialog,
    AddSharedProjectDialog,
    ImportSharedProjectsDialog,
  },
  computed: {
    ...mapGetters({
      user: "auth/user",
    }),
  },
  mounted() {
    this.initMap();
    this.fetchData();
  },
  methods: {
    initMap() {
      try {
        this.map = new window.google.maps.Map(this.$refs["map"], {
          center: { lat: 33.4039313093639, lng: 44.14819337500002 },
          zoom: 7,
          disableDefaultUI: true,
          zoomControl: true,

          styles: [
            {
              elementType: "geometry",
              stylers: [
                {
                  color: "#111e36",
                },
              ],
            },
            {
              elementType: "labels.icon",
              stylers: [
                {
                  visibility: "simplified",
                },
              ],
            },
            {
              elementType: "labels",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "administrative",
              elementType: "geometry",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
            {
              featureType: "administrative.country",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "administrative.land_parcel",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "administrative.locality",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#bdbdbd",
                },
              ],
            },
            {
              featureType: "poi",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#ffffff",
                },
              ],
            },
            {
              featureType: "poi.park",
              elementType: "geometry",
              stylers: [
                {
                  color: "#181818",
                },
              ],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#616161",
                },
              ],
            },
            {
              featureType: "poi.park",
              elementType: "labels.text.stroke",
              stylers: [
                {
                  color: "#1b1b1b",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "geometry.fill",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "road",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "road.arterial",
              elementType: "geometry",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "road.highway",
              elementType: "geometry",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "road.highway.controlled_access",
              elementType: "geometry",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "road.local",
              elementType: "labels.text.fill",
              stylers: [
                {
                  visibility: "off",
                },
              ],
            },
            {
              featureType: "transit",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#757575",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "geometry",
              stylers: [
                {
                  color: "#0f7099",
                },
              ],
            },
            {
              featureType: "water",
              elementType: "labels.text.fill",
              stylers: [
                {
                  color: "#3d3d3d",
                },
              ],
            },
          ],
        });
      } catch (e) {
        console.log(e);
      }
    },
    async fetchData() {
      //this.cities = JSON.parse(localStorage.getItem("apiDataCity"));
      //this.stats = JSON.parse(localStorage.getItem("apiDataStats"));
      //if(this.stats == null || this.cities == null){
      this.loadingDialog = true;
      let citiesCall = axios.post(`Governorates/getList`);
      let statsCall = axios.post(`SharedCompany/getList`);
      await axios.all([citiesCall, statsCall]).then(
        axios.spread((...responses) => {
          this.cities = responses[0].data.items;
          this.stats = responses[1].data.items;
          this.loadingDialog = false;
          //localStorage.setItem("apiDataCity", JSON.stringify(this.cities));
          //localStorage.setItem("apiDataStats", JSON.stringify(this.stats));
        })
      );
      //}
    },
    fetchProjects(city) {
      const formData = new FormData();
      formData.append("governorate_id", city.id);
      axios
        .post("SharedCompany/getList", formData)
        .then((res) => {
          this.loadingDialog = false;
          this.selectedCitySharedProjects = res.data.items;
          this.selectedCity = city;
          this.cityDialog = true;
          console.log(this.selectedCity);
          console.log(this.selectedCitySharedProjects);
        })
        .catch(() => {
          this.loadingDialog = false;
        });
    },
    AddProject() {
      this.addProjectDialog = true;
    },
    ImportProject() {
      this.importProjectDialog = true;
    },
    getLat(city) {
      var position = city.coordinates;
      var latlng = position.split(",");
      var latitude = parseFloat(latlng[0]);
      return latitude;
    },
    getLng(city) {
      var position = city.coordinates;
      var latlng = position.split(",");
      var longitude = parseFloat(latlng[1]);
      return longitude;
    },
    getMap(callback) {
      let vm = this;
      function checkForMap() {
        if (vm.map) callback(vm.map);
        else setTimeout(checkForMap, 200);
      }
      checkForMap();
    },
    async showMarkerDialog(city) {
      this.sleep(200);
      this.loadingDialog = true;
      this.fetchProjects(city);
    },
    sleep(ms) {
      return new Promise((resolve) => setTimeout(resolve, ms));
    },
    itemRowBackground: function(item, index) {
      console.log(item);
      if (index % 2 == 0) {
        return "style-1";
      } else {
        return "style-2";
      }
    },
  },
};
</script>
<style scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
.wrapper,
.wrapper #map {
  width: 100%;
  height: 100%;
}

.wrapper .stats {
  position: absolute;
  z-index: 1;
  top: 16px;
  left: 22px;
}
.wrapper .header img {
  width: 100%;
}
.wrapper .foo {
  height: 55px;
  position: absolute;
  z-index: 1;
  bottom: 20%;
  right: 0.3%;
}
.sim-table {
  background: none;
  color: black;
}
.sim-table tr:hover {
  background-color: #2a2e35 !important;
  color: white;
}
.style-1 td {
  background-color: rgba(42, 46, 53, 0.8);
  color: white;
  font-size: 1.1em !important;
}
.style-2 td {
  background-color: rgba(42, 46, 53, 0.6);
  color: white;
  font-size: 1.1em !important;
}
</style>
